export interface ConfirmationPreferences {
  speechEnabled: boolean;
  fastConfirmEnabled: boolean;
}

export type ConfirmationPath = "speak_then_confirm" | "fast_confirm" | "visual_confirm";

export function confirmationPath(
  preferences: ConfirmationPreferences,
  fastRequested: boolean,
): ConfirmationPath {
  if (fastRequested && preferences.fastConfirmEnabled) {
    return "fast_confirm";
  }

  if (preferences.speechEnabled) {
    return "speak_then_confirm";
  }

  return "visual_confirm";
}

export function confirmationSummary(parts: readonly string[]): string {
  return parts
    .map((part) => part.trim())
    .filter(Boolean)
    .join("، ");
}
